import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Context } from 'src/app/shared/models/context';
import { ChangePassword, Company, EmployeeData, Message } from 'src/app/shared/models/domain';
import { AuthResponse, AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ProfileService } from 'src/app/shared/services/profile.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  @Input() employee: EmployeeData;
  @Input() company: Company;
  @Input() context: Context;
  public session: AuthResponse = {} as AuthResponse;
  public changePassword: ChangePassword;
  public changePasswordForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;

  constructor(
    private profileService: ProfileService,
    private authService: AuthService,
    private fb: FormBuilder,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.changePassword = {} as ChangePassword;
    this.session = this.authService.getSession();
    this.setChangePassword(this.changePassword);
  }

  private setChangePassword(changePassword: ChangePassword) {
    if (!changePassword) changePassword = {
      username: '',
      oldPass: '',
      newPass: '',
    } as ChangePassword
    this.changePasswordForm = this.fb.group({
      username: this.fb.control(changePassword.username, [Validators.required]),
      oldPass: this.fb.control(changePassword.oldPass, [Validators.required]),
      newPass: this.fb.control(changePassword.newPass, [Validators.required]),
      confirm: this.fb.control('', [Validators.required]),
    });
    this.changePasswordForm.valueChanges.subscribe(value => this.modified = true);

  }

  get c() {
    return this.changePasswordForm.controls;
  }

  public OnSubmit(inProgress?: any) {
    this.submitted = true;
    const password: ChangePassword = this.changePasswordForm.value;
    if (this.changePasswordForm.valid) {
      if (!this.modified) {
        this.commonService.setToastr(200, `Password for ${password.username} has been updated successfully!`);
        return;
      }
      if (password.oldPass && password.newPass === password.oldPass) {
        return;
      }
      if (password.newPass !== password.confirm) {
        return;
      }
      this.profileService.upsertPassword(password).subscribe({
        next: (response: Message) => {
          if (!response.failed) {
            this.commonService.setToastr(200, response.text);
            this.authService.signout();
          } else {
            this.commonService.setToastr(500, response.text);
          }
        },
        error: (error: HttpErrorResponse) => {
          inProgress.value = false;
          this.commonService.setToastr(500, error?.error?.text || error.error);
        },
      });
    }
  }
  
  get cpf() {
    return this.changePasswordForm.controls;
  }

  public showPassword(value) {
    this.commonService.showPassword(value);
  }
}